import {UserDto} from "../../account/dto/UserDto";
import {DepartmentDto} from "../../account/dto/DepartmentDto";

export class DepartmentUserDto {
    id: string = '';
    code: string = '';
    name: string = '';
    userId: string = '';
    userName: string = '';
    userMobile: string = '';

    constructor(depart: DepartmentDto, user: UserDto) {
        this.id = depart.id;
        this.name = depart.name;
        this.code = depart.code;
        this.code = depart.code;
        this.userId = user.id;
        this.userName = user.fullName;
        this.userMobile = user.mobile;
    }
}